export default __webpack_public_path__ + "static/media/CorpayV.10fc8e15.png";